import './style.scss';

import React from 'react';
import { Button, Text, Title } from '@gjensidige/builders-components';
import { Damage } from '@gjensidige/builders-icons/symbols';

interface Props {
  headingText: string;
  descriptionText: string;
  primaryButtonLabel: string;
  primaryBtnOnClick: { (): void };
  shouldDisplaySecondaryBtn?: boolean;
  secondaryBtnOnClick?: { (): void };
  secondaryBtnLabel?: string;
  imageSrc?: string;
  imageAlt?: string;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const createMarkup = (message: any) => {
  return { __html: message };
};

export type ErrorPageProps = Props;

export const ErrorPage: React.FC<ErrorPageProps> = ({
  imageAlt = 'Error page image',
  shouldDisplaySecondaryBtn = false,
  imageSrc,
  headingText,
  descriptionText,
  primaryBtnOnClick,
  primaryButtonLabel,
  secondaryBtnOnClick,
  secondaryBtnLabel
}: ErrorPageProps) => {
  window.scrollTo(0, 0);
  return (
    <div className="error-page-wrapper">
      <div className="error-image-section">
        {imageSrc ? <img src={imageSrc} alt={imageAlt} /> : <Damage />}
      </div>
      <div className="error-info-wrapper">
        <div className="error-info-header">
          <Title as="h2" size="4" className="error-info-title">
            {headingText}
          </Title>
        </div>
        <div className="error-info-description">
          <Text
            size="body"
            dangerouslySetInnerHTML={createMarkup(descriptionText)}
          ></Text>
        </div>
      </div>
      <div className="footer-btn">
        {shouldDisplaySecondaryBtn && (
          <Button variant="action" onClick={secondaryBtnOnClick} arrow="left">
            {secondaryBtnLabel}
          </Button>
        )}
        <Button
          variant="primary"
          flexible={!shouldDisplaySecondaryBtn}
          onClick={primaryBtnOnClick}
          className="footer-primary-btn"
        >
          {primaryButtonLabel}
        </Button>
      </div>
    </div>
  );
};
